module.exports = __webpack_public_path__ + "img/BTC.766d32ec.svg";